var _ = require('lodash');
window.$ = window.jQuery = require('jquery');

require('materialize-css');
require('sweetalert');
require('./create');
require('./filter');
require('./edit');
require('./delete');

//require('./views/index');

const flashcanvas = require('./flashcanvas');
const jSignature = require('./jSignature.min');
//require('./informed');
var contLogin,campo,emailRegex;
var $sigdiv;
var signatureValidation;

function importarScript(nombre) {
    var s = document.createElement("script");
    s.src = https + nombre;
    document.querySelector("head").appendChild(s);
}

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#modalLogin').modal('open');
        },0);
    }
    window.load = cargar();
    $('.modal').modal();
    $('select').formSelect();
});


$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$('.btnFormLogin').on('click',function () {
    Login();
});

function Login() {
    $('#user').removeClass('error');
    $('#pass').removeClass('error');
    var contLogin = 1;
    if ($.trim($("#user").val()) == "" ) {
        contLogin = 0;
        $('#user').addClass('error');
    }

    if ($.trim($("#pass").val()) == "" ) {
        contLogin = 0;
        $('#pass').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    var email = $('#user').val();
    var password = $('#pass').val();

    $.ajax({
        type: "post",
        url: https + "loginSignature",
        data: {
            user: email,
            pass: password
        },
        success: function (data) {
            if ($.trim(data) > 0) {
                //$('#modalLogin').modal('close');
                location.href = https + 'contract/'+data;
            } else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
}

$('.btnFormLoginAdmin').on('click',function () {
    LoginAdmin();
});

function LoginAdmin() {
    $('#user').removeClass('error');
    $('#pass').removeClass('error');
    var contLogin = 1;
    if ($.trim($("#user").val()) == "" ) {
        contLogin = 0;
        $('#user').addClass('error');
    }

    if ($.trim($("#pass").val()) == "" ) {
        contLogin = 0;
        $('#pass').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    var email = $('#user').val();
    var password = $('#pass').val();

    $.ajax({
        type: "post",
        url: https + "loginSignatureAdmin",
        data: {
            user: email,
            pass: password
        },
        success: function (data) {
            if ($.trim(data) > 0) {
                //$('#modalLogin').modal('close');
                location.reload();
            } else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
}

require('./signature');